import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from '../../../baseApp/shared/components/searchForm/SearchForm';
import { plannedOrHistoricVisitsSearchFields } from '../utils/searchFields';
import DataTable from '../../../baseApp/shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';
import Alert from "../../../baseApp/shared/components/alerts/Alert";
import IconButton from './../../../baseApp/shared/components/others/IconButton';
import { CompareDatesUtils } from '../../../baseApp/shared/utils/DateTimeUtils';
import UserHasPermission, { appModules, modulesActions } from '../../../baseApp/roles/components/UserHasPermission';

const PlannedVisitorsOrHistoricPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    data = [],
    isHistoric,
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    alert,
    sort: {
        property = "",
        direction = "ASC"
    },
    onPageChange,
    onPageSizeChange,
    handleCheckInClicked = () => { },

    buildingList = []
}) => {
    const historicColumns = [{
        Header: I18n.t("visits.list.visitorName"),
        accessor: "visitor.name",
        sortable: true
    }, {
        Header: I18n.t("visits.list.email"),
        id: "visitor.email",
        accessor: visit => visit.visitor.email,
        sortable: true
    }, {
        Header: I18n.t("visits.list.date"),
        id: "checkInTimestamp",
        accessor: visit => visit.checkInOut,
        sortable: true
    }, {
        Header: I18n.t("visits.list.building"),
        id: "building.name",
        accessor: visit => visit.entity.name,
        sortable: true
    }, {
        Header: I18n.t("visits.list.visitHost"),
        accessor: "visitHost",
        sortable: true
    }, {
        Header: I18n.t("visits.list.checkOutType"),
        id: "checkoutType",
        accessor: visit => {
            const translation = "visits.checkOutTypes." + visit.checkoutType;
            return I18n.t(translation)
        }
    }];

    const plannedVisitorsColumns = [{
        Header: I18n.t("visits.list.visitorName"),
        accessor: "visitor.name",
        sortable: true
    }, {
        Header: I18n.t("visits.list.email"),
        id: "visitor.email",
        accessor: visit => visit.visitor.email,
        sortable: true
    }, {
        Header: I18n.t("visits.list.date"),
        id: "expectedCheckInTimestamp",
        accessor: visit => visit.checkInDate + " " + visit.checkInTime,
        sortable: true
    }, {
        Header: I18n.t("visits.list.visitHost"),
        accessor: "visitHost",
        sortable: true
    }, {
        Header: I18n.t("visits.list.building"),
        id: "building.name",
        accessor: visit => visit.entity.name,
        sortable: true
    }];

    return <div className="page_background">
        <Alert
            {...alert}
        />
        <SearchForm
            content={plannedOrHistoricVisitsSearchFields(searchFieldsValues, buildingList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            hideAddButton={true}
        />
        <div>
            <DataTable
                hasEdit={false}
                hasDelete={false}

                //State dependent
                data={data}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={isHistoric ? historicColumns : plannedVisitorsColumns}
                hasRowSelector={!isHistoric}
                rowIsSelectable={row => CompareDatesUtils.dateIsOnTheSameDayAsDate(row.expectedCheckInTimestamp)}
                customMultiSelectOptions={isHistoric ?
                    [] :
                    [
                        (selectedEntries, numberOfSelectedEntries) =>
                            buildCheckInButton(selectedEntries, numberOfSelectedEntries, handleCheckInClicked)
                    ]
                }
                hasStatusBar={false}
                rowIsClickable={false}
            />
        </div>
    </div>
};

function buildCheckInButton(selectedEntries, numberOfSelectedEntries, handleCheckInClicked) {
    return (
        <UserHasPermission
            appModule={appModules.CHECK}
            action={modulesActions.IN}
        >
            <IconButton
                textMode={true}
                alt={I18n.t('visits.list.manualCheckIn')}
                classes="check-in-btn ml-2"
                disabled={numberOfSelectedEntries === 0}
                handleIconClick={() => handleCheckInClicked(selectedEntries)}
            />
        </UserHasPermission>
    );
}

PlannedVisitorsOrHistoricPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    handleCheckoutClicked: PropTypes.func,
    data: PropTypes.array,
    pages: PropTypes.number,
    onFetchData: PropTypes.func,
};

export default PlannedVisitorsOrHistoricPage;

